"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modelFactory;

var _modelUtil = _interopRequireDefault(require("@leverege/model-util"));

var _AlertModel = _interopRequireDefault(require("./AlertModel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ALERT_TYPES = Object.freeze(['motionAfterHours', 'leftLocationAfterHours', 'enteredZone', 'exitedZone', 'locatorRemoved', 'farFromSite', 'suspectedDriveOff', 'closeOfBusiness', 'offlinePairedLocators', 'pendingSale']);
const EDITABLE_VALUES_BY_ALERT_TYPE = Object.freeze({
  motionAfterHours: ['vehicleTypes'],
  leftLocationAfterHours: ['vehicleTypes'],
  enteredZone: ['vehicleTypes'],
  exitedZone: ['vehicleTypes'],
  locatorRemoved: ['vehicleTypes'],
  farFromSite: ['vehicleTypes', 'threshold'],
  suspectedDriveOff: ['active'],
  closeOfBusiness: ['active'],
  offlinePairedLocators: ['active'],
  pendingSale: ['active']
});

function modelFactory(options) {
  const {
    vehicleTypes
  } = options;
  const alertModel = (0, _AlertModel.default)({
    vehicleTypes
  });
  const TYPE = 'recovr.LocationAlertsModel';

  function create() {
    return {
      type: TYPE,
      alerts: createDefaultAlerts()
    };
  }

  function createDefaultAlerts() {
    return ALERT_TYPES.reduce((prev, curr) => {
      prev[curr] = alertModel.create(curr); // eslint-disable-line no-param-reassign

      return prev;
    }, {});
  }

  function createDefaultAlertAccessors() {
    return ALERT_TYPES.reduce((prev, curr) => {
      return { ...prev,
        ..._modelUtil.default.createAllValue(`alerts/${curr}`, `${curr}Alert`, undefined, {
          defaultValue: alertModel.create(curr)
        })
      };
    }, {});
  }

  function createDefaultAccessors() {
    return { ...createDefaultAlertAccessors()
    };
  }

  function hasActiveAlerts(model) {
    return Object.keys(model.alerts).some(key => alertModel.hasActiveAlerts(model.alerts[key]));
  }

  return {
    TYPE,
    create,
    ...createDefaultAccessors(),
    alertTypes: ALERT_TYPES,
    editableValuesByAlertType: EDITABLE_VALUES_BY_ALERT_TYPE,
    hasActiveAlerts
  };
}